import { useStore } from 'dg-web-shared/lib/Flux.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import { Search } from '../../../ui/search/Search.tsx';
import * as SearchState from '../../state/SearchState.ts';
import * as ClearancePermitListState from '../../state/ClearancePermitListState.ts';
import * as PermitCreateState from '../../../permit-detail/state/PermitCreateState.ts';

export function SearchContainer() {
    const { storeState, update } = useStore(store => ({
        search: SearchState.get(store),
        permitCreateLayout: PermitCreateState.Layout.get(store),
        layout: ClearancePermitListState.Layout.get(store),
    }));
    const { language } = useLanguage();

    return (
        <Search
            searchValue={storeState.search.searchValue}
            selected={
                storeState.layout.selectedTab ===
                ClearancePermitListState.SelectedTab.Search
            }
            language={language}
            onSearchFieldChange={(value: string) => {
                update(store =>
                    SearchState.stateWrite(store, {
                        searchValue: value,
                    }),
                );
            }}
            onSelect={() =>
                update(store =>
                    ClearancePermitListState.Layout.stateWrite(store, {
                        selectedTab:
                            ClearancePermitListState.SelectedTab.Search,
                    }),
                )
            }
            mousetrap={storeState.permitCreateLayout.createEnabled || false}
        />
    );
}
